<template>
  <b-modal id="modalContratarProduto" size="lg" :title="obterTituloModal" cancel-title='Fechar' ok-title='Ok' @show="resetarDados" @ok="aceitarContrato" @hidden="tratarEventoFecharModal">
    <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
    <form>
      <div class="form-row">
        <div class="row col-md-12">
          <div class="form-group col-md-12 col-lg-12 col-xl-6">
            <label for="senha">Senha</label>
            <input type="password" id="senha" v-model="formulario.senha_usuario" :disabled="flagsDeControle.carregandoDados.status" class="form-control">
            <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.senha_usuario}}</div>
          </div>
          <div class="form-group col-md-12 col-lg-12 col-xl-5">
            <label for="quantidade">Quantidade</label>
            <input type="number" id="quantidade" @input="mascaraQuantidade" v-model="formulario.quantidade" :disabled="flagsDeControle.carregandoDados.status" class="form-control">
            <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.quantidade}}</div>
          </div>
        </div>
      </div>
      <div class="form-group col-md-12">
        <a href="/pdf/Termos_de_Uso_Mirt.pdf" target="_blank">Contrato de uso</a><br /><b-form-checkbox
        id="aceite_contrato"
        v-model="formulario.aceite_contrato"
        name="aceite_contrato"
        :value="true"
        class="mt-2"
        :unchecked-value="false"
      >
        Confirmar aceite contrato
      </b-form-checkbox>
      <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.aceite_contrato}}</div>
      </div>
    </form>

    <slot name="mensagem">
    </slot>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button class="botoes" variant="outline-success btn-sm" :disabled="flagsDeControle.carregandoDados.status" @click="ok()">Contratar Produto</b-button>
      <b-button class="botoes" variant="outline-primary btn-sm" :disabled="flagsDeControle.carregandoDados.status" @click="cancel()">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import ContratarProduto from './js/contratar-produto'
export default ContratarProduto
</script>
